/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Company_Companydetails_Addresspostalcode3Inputs */

const ja_company_companydetails_addresspostalcode3 = /** @type {(inputs: Company_Companydetails_Addresspostalcode3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`TOCビル 11F`)
};

const en_company_companydetails_addresspostalcode3 = /** @type {(inputs: Company_Companydetails_Addresspostalcode3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`141-0031`)
};

/**
* | output |
* | --- |
* | "141-0031" |
*
* @param {Company_Companydetails_Addresspostalcode3Inputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
const company_companydetails_addresspostalcode3 = /** @type {((inputs?: Company_Companydetails_Addresspostalcode3Inputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Company_Companydetails_Addresspostalcode3Inputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_company_companydetails_addresspostalcode3(inputs)
	return en_company_companydetails_addresspostalcode3(inputs)
});
export { company_companydetails_addresspostalcode3 as "company_companyDetails_addressPostalCode" }